import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as popoverActions from '~/actions/popover';
import PopoverWithEscKey from '~/components/PopoverWithEscKey';
type TooltipProps = {
  popoverActions: object;
  popoverState: object;
  id?: string;
  place?: string;
  minWidthClass?: string;
  maxWidthClass?: string;
  width?: string;
  className?: string;
  textAlign?: string;
  content?: string | object;
};
class Tooltip extends React.Component<TooltipProps, {}> {
  componentWillUnmount() {
    const { popoverState, id } = this.props;
    const isOpen = popoverState[id] || false;
    if (isOpen) {
      this.toggleClosed();
    }
  }
  isPopOverOpen = () => {
    const { popoverState, id } = this.props;
    return popoverState[id] || false;
  };
  toggleOpen = () => {
    if (!this.isPopOverOpen()) {
      this.props.popoverActions.openPopover(this.props.id);
    }
  };
  toggleClosed = () => {
    if (this.isPopOverOpen()) {
      this.props.popoverActions.closePopover(this.props.id);
    }
  };
  render() {
    const {
      children,
      place = 'below',
      minWidthClass = 'min-width--300',
      maxWidthClass = 'max-width--675',
      width,
      className = '',
      textAlign = 'text--left',
      content,
    } = this.props;
    const isOpen = this.isPopOverOpen();
    const tooltipContent = <div className={textAlign}>{content}</div>;
    return (
      <PopoverWithEscKey
        isOpen={isOpen}
        body={tooltipContent}
        className={`popover--dark zIndex-9--dialog ${className} ${minWidthClass} ${maxWidthClass} ${width}`}
        place={place}
        onOuterAction={this.toggleClosed}
      >
        <div onMouseOver={this.toggleOpen} onMouseOut={this.toggleClosed}>
          {children}
        </div>
      </PopoverWithEscKey>
    );
  }
}
function mapStateToProps(state) {
  return {
    popoverState: state.popoverState,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    popoverActions: bindActionCreators(popoverActions, dispatch),
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Tooltip);
